import { Card, Icon, Text, Flex } from '@chakra-ui/react';
import { IoMailOpenOutline, IoChatboxOutline, IoLogoWhatsapp } from 'react-icons/io5';
import HelpMessageIcon from './HelpMessageIcon';
import MerchantContext from '../contexts/MerchantContext';
import { useContext } from 'react';

const HelpMessage = (): JSX.Element => {
  const { merchant } = useContext(MerchantContext);

  return (
    <Card width={['290px', '326px', '315px']} variant={'unstyled'} fontSize={'12px'}>
      <Flex gap={2}>
        <Icon as={IoChatboxOutline} boxSize={'26px'} p={1} />
        <Card variant={'unstyled'} gap={'8px'}>
          <Text>
            <Text fontWeight={700} as={'span'}>
              ¿Necesitas ayuda?
            </Text>{' '}
            Si deseas mayor información sobre el estado actual de tu operación, contáctanos en las siguientes vías para
            atención al cliente:
          </Text>
          <HelpMessageIcon
            IconComponent={IoMailOpenOutline}
            text={merchant?.supportEmail ?? ''}
            url={`mailto:${merchant?.supportEmail}`}
          />
          <HelpMessageIcon
            IconComponent={IoLogoWhatsapp}
            text={merchant?.supportWhatsapp?.slice(-10) ?? ''}
            url={`https://wa.me/${merchant?.supportWhatsapp}`}
          />
        </Card>
      </Flex>
    </Card>
  );
};

export default HelpMessage;
